/* eslint-disable */
export const isMobile = () => $(window).width() <= 767;
export const isTablet = () => $(window).width() >= 767 && $(window).width() < 1024;
export const isLaptop = () => $(window).width() >= 1024;
